module.exports = __webpack_public_path__ + "static/img/teach-img03-01.86c031f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resolution/teach-img03-01.png
// module id = EGw0
// module chunks = 7